import { render, staticRenderFns } from "./ButtonsLevelCell.vue?vue&type=template&id=ad2f2f8a&scoped=true"
import script from "./ButtonsLevelCell.vue?vue&type=script&lang=js"
export * from "./ButtonsLevelCell.vue?vue&type=script&lang=js"
import style0 from "./ButtonsLevelCell.vue?vue&type=style&index=0&id=ad2f2f8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f2f8a",
  null
  
)

export default component.exports